/**
 * @generated SignedSource<<82ce8674ea058f57d48f81ddebd91f03>>
 * @relayHash bbded9bc626643fc8c3d0b2a9a6980d1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbded9bc626643fc8c3d0b2a9a6980d1

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type TryToReassignAgentInput = {
  id: string;
};
export type useTryToReassignAgentMutation$variables = {
  input: TryToReassignAgentInput;
};
export type useTryToReassignAgentMutation$data = {
  readonly tryToReassignAgent: {
    readonly appointment: {
      readonly appointmentId: number;
      readonly appointmentType: AppointmentType;
      readonly assignedTo: string | null;
      readonly id: string;
      readonly service: Service;
      readonly specialty: ServiceSpecialty;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: "AppointmentIsNotAutomaticallyReassignable";
      readonly message: string;
    } | {
      readonly __typename: "AppointmentNotFound";
      readonly message: string;
    } | {
      readonly __typename: "FeatureIsDisabledDuringDayLightSavingTime";
      readonly message: string;
    } | {
      readonly __typename: "NoSuitableAgentFound";
      readonly message: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type useTryToReassignAgentMutation = {
  response: useTryToReassignAgentMutation$data;
  variables: useTryToReassignAgentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "specialty",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = [
  (v3/*:: as any*/),
  (v4/*:: as any*/)
],
v6 = [
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTryToReassignAgentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TryToReassignAgentPayload",
        "kind": "LinkedField",
        "name": "tryToReassignAgent",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "AppointmentNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "NoSuitableAgentFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "AppointmentIsNotAutomaticallyReassignable",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "FeatureIsDisabledDuringDayLightSavingTime",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useTryToReassignAgentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TryToReassignAgentPayload",
        "kind": "LinkedField",
        "name": "tryToReassignAgent",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "AppointmentNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "NoSuitableAgentFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "AppointmentIsNotAutomaticallyReassignable",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "FeatureIsDisabledDuringDayLightSavingTime",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bbded9bc626643fc8c3d0b2a9a6980d1",
    "metadata": {},
    "name": "useTryToReassignAgentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "de8e15b40a5b322733c50d9628abe671";

export default node;
